import {Injectable} from '@angular/core';
import {ApiService} from "./api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {Pagination} from "../models/pagination";
import {SocietyAdminRequest} from "@core/shared/models/society-admin-request";


@Injectable({
    providedIn: 'root'
})
export class SocietyAdminRequestService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient,
    ) {
    }

    public getItemsAPI(id: number, params?: string[]): Observable<SocietyAdminRequest[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');
        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/${id}/societyAdminRequests`;
        params = params || [];
        params.push('disablePagination=1');
        if (params.length > 0) {
            url = `${url}?${params.join('&')}`;
        }
        return this._httpClient.get<SocietyAdminRequest[]>(url, {
            headers: headers
        });

    }

    public getUserItemsAPI(id: number, params?: string[]): Observable<SocietyAdminRequest[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/users/${id}/societyAdminRequests`;

        params = params || [];

        params.push('disablePagination=1');

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<SocietyAdminRequest[]>(url, {
            headers: headers
        });
    }

    public getPaginationItemsAPI(id: number, params?: string[]): Observable<Pagination<SocietyAdminRequest[]>> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');
        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/${id}/societyAdminRequests`;
        params = params || [];
        if (params.length > 0) {
            url = `${url}?${params.join('&')}`;
        }
        return this._httpClient.get<Pagination<SocietyAdminRequest[]>>(url, {
            headers: headers
        });

    }

    public createItemAPI(id: number): Observable<void> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<void>(`${this._apiService.getApiUrl(false, true)}/users/${id}/societyAdminRequests`, {},{
            headers: headers
        });
    }

    public updateItemAPI(id: number, data: object): Observable<void> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.patch<void>(`${this._apiService.getApiUrl(false, true)}/societyAdminRequests/${id}`, data,{
            headers: headers
        });
    }

    public deleteItemAPI(id: number): Observable<void> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.delete<void>(`${this._apiService.getApiUrl(false, true)}/societyAdminRequests/${id}`,{
            headers: headers
        });
    }
}
